import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "How does coaching with TonyBrand29 work?",
    a: "We begin with a discovery session, map your baseline across the four pillars, then meet regularly with small, measurable protocols between calls.",
  },
  {
    q: "Are you accepting new coaching clients?",
    a: "A limited number each quarter. Send a note through the contact form and the team will share current availability.",
  },
  {
    q: "What happens after I buy an ebook?",
    a: "Checkout is handled securely by Stripe. As soon as payment clears, a private download link is emailed to you automatically.",
  },
  {
    q: "Is this a substitute for medical care?",
    a: "Coaching complements but never replaces your primary physician. For urgent or clinical concerns, always consult your doctor.",
  },
];

export const FAQ = () => {
  return (
    <section id="faq" className="max-w-4xl mx-auto px-6 lg:px-10 py-24 lg:py-32">
      <div className="text-center mb-14">
        <span className="overline">Questions</span>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-light text-brand-text mt-4">
          Good to know.
        </h2>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-${i}`}
              className="border-brand-line"
            >
              <AccordionTrigger className="text-left font-serif text-xl lg:text-2xl text-brand-text hover:no-underline hover:text-brand-gold py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-brand-dim text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </motion.div>
    </section>
  );
};
